import { useState, useEffect, useMemo } from 'react';
import { usePreprocessedDict } from './use-preprocessed-dict';
import { loadDictData } from '../utils';
import { ZhongwenDictionary } from '../ZhongwenDictionary';
import memoize from 'lodash/memoize';

export const useZhongwenDictionary = (textNodes) => {
  const [zhongwenDictionary, setZhongwenDictionary] = useState();

  const preprocessedDict = useMemo(() => {
    let dict = new Map();

    if (!zhongwenDictionary || !textNodes) {
      return dict;
    }

    const passage = textNodes.map((textNode) => textNode.textContent).join('');

    let nextResults = [];

    eachChar(textNodes, ({ textNode, passageOffset, textOffset, charOffset }) => {
      const text = passage.substring(passageOffset);
      const { data: results = [] } = zhongwenDictionary.wordSearch(text) ?? {};

      zhongwenDictionary.parseResults(results).forEach((dictWord) => {
        nextResults.push({ textPath: [], dictWord });
      });

      let tempNextResults = [];

      nextResults.forEach((result) => {
        const { dictWord } = result;
        result.textPath.push({ textNode, textOffset, charOffset });

        if (!dict.has(textNode)) {
          dict.set(textNode, []);
        }

        const textEntries = dict.get(textNode);
        textEntries[charOffset] = [result].concat(textEntries[charOffset] ?? []);

        if (result.textPath.length < dictWord.text.length) {
          tempNextResults.push(result);
        }
      });

      nextResults = tempNextResults;
    });

    return dict;
  }, [zhongwenDictionary, textNodes]);

  useEffect(() => {
    (async () => {
      const zhongwenDictionary = await loadDictionary();
      setZhongwenDictionary(zhongwenDictionary);
    })();
  }, []);

  return usePreprocessedDict(preprocessedDict, getWords);
};

export const loadDictionary = memoize(async () => {
  const [wordDict, wordIndex, grammarKeywords] = await loadDictData();
  return new ZhongwenDictionary(wordDict, wordIndex, grammarKeywords);
});

const eachChar = (textNodes, callback) => {
  let passageOffset = 0;

  textNodes.forEach((textNode, textOffset) => {
    const text = textNode.textContent;

    for (let charOffset = 0; charOffset < text.length; charOffset++) {
      const char = text[charOffset];
      callback({ char, textNode, passageOffset, textOffset, charOffset });
      passageOffset++;
    }
  });
};

const getWords = (results) => ({
  dictWords: results.map(({ dictWord }) => dictWord),
});
